import styled from "styled-components";
import FlexBox from "../../../FlexBox/FlexBox";

export const _CompositionItemRoot = styled(FlexBox)(() => {
  return {
    cursor: "pointer",
  };
});

export const _CompositionItemModalContainer = styled(FlexBox)<{}>(() => {
  return {
    width: "100%",
    margin: "0 auto",
  };
});
